import { ContentHeader } from "@components/contentHeader/contentHeader";
import { Field } from "@components/field/field";
import { SelectField } from "@components/field/selectField";
import { Flex } from "@components/flex/flex";
import { GetEventTitlesQuery } from "@graphql2/types";
import { getText } from "@utils/getText";
import { validateHexColor } from "@utils/validators/validateHex";
import { Card, Checkbox, Form, Select } from "antd";
import * as React from "react";
import { FormattedMessage } from "react-intl";

export interface GeneralSettingsCardProps {
    disabled?: boolean;
    onChange(): void;
    eventTitles: Omit<GetEventTitlesQuery["events"][0], "start" | "end">[]|undefined;
}

export const GeneralSettingsCard: React.FC<GeneralSettingsCardProps> = (props) => {
    const { disabled, onChange, eventTitles } = props;
    const sharedProps = {
        disabled,
        onBlur: onChange
    };

    return (
        <Card>
            <ContentHeader
                title={<FormattedMessage id="settings" />}
            />
            <Flex>
                <div>
                    <SelectField
                        id="events"
                        label={<FormattedMessage id="events" />}
                        mode="multiple"
                        name="events"
                        placeholder={<FormattedMessage id="placeholder.pleaseSelect" />}
                        {...sharedProps}
                        disabled={!eventTitles || !eventTitles.length}
                    >
                        {(eventTitles && eventTitles.length)
                            && eventTitles.map(event => (
                                <Select.Option
                                    key={event.id}
                                    value={event.id}
                                >
                                    {getText(event.title)}
                                </Select.Option>
                            ))}
                    </SelectField>
                </div>
            </Flex>
            <Form.Item>
                <Field
                    numberType
                    label={<FormattedMessage id="eventsGroup.subscriptionLimit" />}
                    min={1}
                    name="subscriptionsCount"
                    rules={[
                        {
                            required: true,
                            message: <FormattedMessage id="form.isrequired" />
                        }
                    ]}
                />
            </Form.Item>
            <Form.Item>
                <Field
                    label={<FormattedMessage id="eventsGroup.color" />}
                    name="color"
                    rules={[
                        { validator: validateHexColor }
                    ]}
                />
            </Form.Item>
            <Form.Item
                name="dontAllowSubEventIntersection"
                valuePropName="checked"
            >
                <Checkbox>
                    <FormattedMessage id="eventsGroup.dontAllowSubEventIntersection" />
                </Checkbox>
            </Form.Item>
        </Card>
    );
};
